import { Stack, Typography } from '@mui/material';
import { PaymentMethod } from 'features/payments/components/RecurlyAccountInformation/PaymentMethod';
import { Trans, useTranslation } from 'react-i18next';
import { PaymentMethodData } from 'shared/types';
import AppleIcon from 'assets/apple.svg?react';

type BillingDetailsProps = {
  isIosSubscription: boolean;
  paymentMethod?: PaymentMethodData;
};

export const BillingDetails = (props: BillingDetailsProps): JSX.Element => {
  const { isIosSubscription, paymentMethod } = props;
  const { t } = useTranslation();

  if (isIosSubscription) {
    return (
      <Stack direction="row" spacing={0.5} alignItems="center">
        <AppleIcon
          width={16}
          height={16}
          style={{ marginLeft: '-2px' }}
          role="img"
          aria-label="Apple"
        />

        <Typography variant="body2" fontWeight="fontWeightMedium">
          {t('membership.subscription.appleAppStore')}
        </Typography>
      </Stack>
    );
  }

  if (!paymentMethod) {
    return <>-</>;
  }

  if (paymentMethod.paymentType === 'apple_pay') {
    return (
      <PaymentMethod
        type="ApplePay"
        sx={{
          width: 40,
          height: 'auto',
          '& svg': { width: '100%', height: '100%' },
        }}
      />
    );
  }

  if (paymentMethod.paymentType === 'paypal_billing_agreement') {
    return (
      <PaymentMethod
        type="PayPalLogo"
        sx={{
          width: 60,
          height: 'auto',
          '& svg': { width: '100%', height: '100%' },
        }}
      />
    );
  }

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: -0.5 }}>
      <PaymentMethod
        // @ts-expect-error TS doesn't infer correctly here
        type={paymentMethod.cardType}
        sx={{
          width: 25,
          height: 25,
          '& svg': { width: '100%', height: '100%' },
        }}
      />
      <Typography variant="body2" fontWeight="fontWeightMedium">
        <Trans
          i18nKey="membership.subscription.creditCard"
          // @ts-expect-error TS doesn't infer correctly here
          values={{ last4: paymentMethod.lastFour }}
        >
          Credit Card ending in <b>1234</b>
        </Trans>
      </Typography>
    </Stack>
  );
};
